import "stylesheets/decidim/extra_blocks/_tokens.scss";
import "stylesheets/decidim/extra_blocks/extra_blocks.scss";
import "stylesheets/decidim/extra_blocks/verbose_cta.scss";
import "stylesheets/decidim/extra_blocks/dual_path_cta.scss";
import "stylesheets/decidim/extra_blocks/join_steps_cta.scss";
import "stylesheets/decidim/extra_blocks/trust_quote_cta.scss";
import "stylesheets/decidim/extra_blocks/video_hero.scss";
import "stylesheets/decidim/extra_blocks/photo_mission_hero.scss";
import "stylesheets/decidim/extra_blocks/split_story_hero.scss";
import "stylesheets/decidim/extra_blocks/outcome_stats_hero.scss";
import "stylesheets/decidim/extra_blocks/focused_quick_proposal.scss";
import "stylesheets/decidim/extra_blocks/split_fast_proposal.scss";
import "stylesheets/decidim/extra_blocks/video_fast_proposal.scss";
import "stylesheets/decidim/extra_blocks/proposals_aside_fast_proposal.scss";
import "stylesheets/decidim/extra_blocks/fast_proposal_form.scss";
import "stylesheets/decidim/extra_blocks/editorial_prose.scss";
import "stylesheets/decidim/extra_blocks/media_aside.scss";
import "stylesheets/decidim/extra_blocks/topic_trio.scss";
import "stylesheets/decidim/extra_blocks/spacer.scss";
import "stylesheets/decidim/extra_blocks/image.scss";
import "stylesheets/decidim/extra_blocks/video.scss";
import "stylesheets/decidim/extra_blocks/logo_showcase.scss";
import "stylesheets/decidim/extra_blocks/dynamic_logos_settings.scss";
import "stylesheets/decidim/extra_blocks/dynamic_events_settings.scss";
import "stylesheets/decidim/extra_blocks/dynamic_slot_list_settings.scss";
import "stylesheets/decidim/extra_blocks/brand_story.scss";
import "stylesheets/decidim/extra_blocks/roadmap.scss";
import "stylesheets/decidim/extra_blocks/impact_milestones.scss";
import "stylesheets/decidim/extra_blocks/gallery.scss";
import "stylesheets/decidim/extra_blocks/availability.scss";
import "src/decidim/extra_blocks/direct_upload_csrf";
import "src/decidim/extra_blocks/video_upload_accept";
import "src/decidim/extra_blocks/background_video";
import "src/decidim/extra_blocks/fast_proposal_form";
import "src/decidim/extra_blocks/media_aside_slideshow";
import "src/decidim/extra_blocks/roadmap";
import "src/decidim/extra_blocks/dynamic_logos_settings";
import "src/decidim/extra_blocks/dynamic_events_settings";
import "src/decidim/extra_blocks/dynamic_slot_list_settings";
require.context("../images", true);
